import { initVideoTracking } from "../../ui";

import "./pressing-dtf-section.scss";

const getVideo$ = () => document.querySelector(".js-jiffytransfers-landing-v2-pressing-dtf-video");

document.addEventListener("DOMContentLoaded", () => {
  initVideoTracking(getVideo$(), "Pressing Jiffy Transfers is simple and fun");
});
